export default __webpack_public_path__ + "static/media/plain-sticker-w.6fe82bfa.png";